<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
            <div class="col-12  mt-2 py-0">
              <h3 class="m-0 p-0 text-secondary d-inline">Stock</h3>
              <button class="float-right btn btn-primary shadow" v-on:click="formStockActive=!formStockActive">Stock Baru</button>
            </div>
            <transition name="fade">
            <div class="col-12  my-2 py-0" v-if="formStockActive">
                <div class="row p-3 mx-2 bg-white shadow">
                    <div class="col-12 mb-3">
                        <h4 class="my-0 py-0">Form Stock Baru</h4>
                        <hr>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Serial Number</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newStock.serial_number_id" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">ID Transmitter</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newStock.idtransmitter" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">No JB</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newStock.jb_id" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Tanggal</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newStock.date" />
                    </div>

                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="newStockSaved">
                            <div class="alert alert-success" role="alert">
                                Berhasil Menyimpan Stock Baru.
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorNewStock">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1">Gagal Menyimpan Stock Baru.</p>
                                </div>
                                <div v-for="err in errorStockList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="savingNewStock">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <button class="btn btn-primary float-right" type="button" v-on:click="saveNewStock">Submit</button>
                    </div>
                </div>
            </div>
            </transition>

        
          <div class="col-12  my-2 py-0">
            <datatable :datas="stocks" :structure="airtimepriceTableStructure" :init="loadData">
                <template #head>
                    <th>Tindakan</th>
                </template>
                <!-- <template #vendor="{obj}">
                    {{obj.vendor!=null?obj.vendor.vendor_name:'-'}}
                </template> -->
                <template #addon="{idx}">
                    <td>
                        <b-button v-b-modal.modal-edit-po class="btn btn-info mr-2" v-on:click="selectedIdforEdit=idx"><b-icon icon="pencil-square"></b-icon></b-button>
                        <b-button v-b-modal.modal-delete-po v-on:click="selectedToDelete=idx" class="btn btn-danger"><b-icon icon="trash-fill"></b-icon></b-button>
                    </td>
                </template>
            </datatable>
          </div>
        <b-modal id="modal-edit-po" title="Edit data" no-close-on-backdrop size="lg">
            <div class="row" v-if="stocks[selectedIdforEdit]!=undefined">
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Serial Number</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="stocks[selectedIdforEdit].serial_number_id" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">ID Transmitter</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="stocks[selectedIdforEdit].idtransmitter" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">No JB</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="stocks[selectedIdforEdit].jb_id" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Tanggal</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="stocks[selectedIdforEdit].date" />
                </div>
                
                <div class="col-12 mt-3">
                    <div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
                    <div class="alert alert-success" role="alert">
                        Berhasil Update Data Stock.
                    </div>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <div class="w-100 text-right m-0 p-0">
                    <hr> 
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1 text-left">Gagal Update Stock.</p>
                                </div>
                                <div v-for="err in errorStockList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="updating">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-po')">close</b-button>
                        <button class="btn btn-info float-right" type="button" v-on:click="updateStock">Submit</button>
                    </div>
                </div>
            </template>
        </b-modal>
        
        <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-po" title="Konfirmasi hapus data" scrollable no-close-on-backdrop @hide="deleteModalClose">
            <b-container fluid v-if="!loadData">
                <b-row class="pt-1">
                <b-col cols="12" class="my-3">
                    <h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
                    <ul v-if="stocks.length>0">
                        <li>Airtime Price: {{stocks[selectedToDelete].name_airtime_price}}</li>
                        <li>Price: {{stocks[selectedToDelete].price}}</li>
                        <!-- <li>Price: {{airtimeprices[selectedToDelete].vendor!=null?airtimeprices[selectedToDelete].vendor.price:'-'}}</li> -->
                    </ul>
                </b-col>
                <b-col cols="12" class="my-3 text-right"  v-if="deleteState">
                    <div class="d-flex align-items-center justify-content-start">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
                        </div>
                    </b-col>
                    <div class="col-12 mt-3"  v-if="deleted">
                        <div class="w-100 align-items-center justify-content-start">
                            <div class="alert alert-success" role="alert">
                                Berhasil menghapus data stock.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3"  v-if="deleteFail">
                        <div class="w-100 align-items-center justify-content-start">
                            <div class="alert alert-danger" role="alert">
                                Gagal menghapus data stock.
                            </div>
                        </div>
                    </div>
                </b-row>
            </b-container>
            <template #modal-footer>
                <div class="w-100 text-right m-0 p-0">
                <hr>
                <button class="btn btn-danger mr-2" v-on:click="deleteData">Ya, hapus</button>
                <b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-delete-po'):''">Tutup</b-button>
                </div>
            </template>
        </b-modal>
  
      </div>
    </div>
  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    import SmartSearch from '../../components/SmartSearch.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'smart-search':SmartSearch
        },
        data () {
            return {
                 isMobile:false,

                stocks:[],
                searchValue:'',
                loadData:true,
                savingNewStock:false,
                updating:false,
                updateSaved:false,
                deleted:false,
                deleteFail:false,
                deleteState:false,
                selectedToDelete:0,
                errorNewStock:false,
                errorUpdate:false,
                errorStockList:[],
                newStockSaved:false,
                updateSaved:false,
                selectedIdforEdit:0,
                selectedTab:0,
                newAirtimePrice:{
                    name_airtime_price:'',
                    price:''

                },
                formStockActive:false,
                airtimepriceTableStructure:[
                    //label: nama heading, key: nama object property
                    {label:'Airtime',key:'name_airtime_price'},
                    {label:'Price',key:'price'},
                ],
            }
        },
        created(){
            this.getAirtimePrices();
            // var newData = [];
            // for(var x=0;x<100;x++){
            //     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
            // }
            // console.log(newData);
            // this.users = newData;
        },
        methods:{
            getAirtimePrices(url=(this.$baseUrl+'/api/master/airtimeprice')){
                this.loadData=true
                axios.get(url,{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    console.log(result)
                    this.stocks = result.data.data;
                    this.loadData=false
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                        localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err)
                    this.loadData=false
                })
            },
            updateStock(){
                this.updating=true
                this.errorUpdate=false
                axios.put(this.$baseUrl+'/api/master/airtimeprice/'+this.stocks[this.selectedIdforEdit].id,this.stocks[this.selectedIdforEdit],{
                    headers:{'Authorization':'Bearer '+ localStorage.getItem('accessToken')}
                }).then((result)=>{
                    if(result.status=200){
                        this.updating=false
                        this.updateSaved=true
                        setTimeout(() => {
                            this.updateSaved=true
                        }, 1500);
                    }
                    console.log(result)
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                        localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    this.updating=false
                    this.errorUpdate=true
                    console.log(err.response)
                })
            },
            updateNewPoPPN(data){
                this.newPurchaseOrder.ppn=data
            },
            // saveNewPurchaseOrder(){
            //     this.savingNewAirtimePrice=true
            //     this.errorNewAirtimePrice=false
            //     console.log(this.newPurchaseOrder)
            //     if(this.newPurchaseOrder.name_airtime_price!='' && this.newPurchaseOrder.price){
            //         axios.post(this.$baseUrl+'/api/master/airtimeprice',
            //         {
            //             name_airtime_price:this.newPurchaseOrder.name_airtime_price,
            //             price:this.newPurchaseOrder.price
            //         },
            //         {
            //             'headers':
            //             {
            //                 'Authorization':'Bearer '+localStorage.getItem('accessToken')
            //             }
            //         }).then((result)=>{
            //             //console.log(result)
            //             if(result.data.create){
            //                 this.getAirtimePrices();
            //             }
            //             this.newAirtimePrice.name_airtime_price='',
            //             this.newAirtimePrice.price='',
            //             this.savingNewAirtimePrice=false
            //             this.newAirtimePriceSaved=true

            //             setTimeout(() => {
            //                 this.newAirtimePriceSaved=false
            //                 this.formAirtimePriceActive=false
            //             }, 1500);

            //         }).catch((err)=>{
          //check if token fail
            //   if(err.response && err.response.status==401){
            //     localStorage.removeItem('accessToken')
            //   this.$router.push('/login')
            //   }
            //             console.log(err.response)
            //             this.errorAirtimePriceList=[]
            //             this.errorAirtimePriceList=Object.values(err.response.data.errors)
            //             console.log(this.errorAirtimePriceList)
            //             this.errorNewAirtimePrice=true
            //             this.savingNewAirtimePrice=false
            //         })
            //     }
            // },
            deleteItem(index){
                console.log('button delete untuk user id: '+index)
            },
            // updateUserRoleValue(newValue){
            //     this.newPurchaseOrder.role=newValue
            // },
            // setNewClientId(newId){
            //     this.newPurchaseOrder.clientId = newId;
            //     console.log(this.newPurchaseOrder.clientId)
            // },
            // updateNewHardwareItemType(value){
            //     this.newPurchaseOrder.itemType=value;
            // },
            // smartSearchUpdated(data,index){
            //     this.newPurchaseOrder.hardware.id[index]=data.id
            //     console.log(this.newPurchaseOrder.hardware.id[index])
            // },
            // smartSearchUpdatedVendor(data,index){
            //     this.newPurchaseOrder.vendor_id[index]=data.id
            //     console.log(this.newPurchaseOrder.vendor_id[index])
            // },
            saveNewStock(){
                //if(this.newPurchaseOrder.no_po!=''){}
                // console.log(this.newPurchaseOrderSaved)
                // return;
                this.savingNewStock=true
                this.errorNewStock=false
                axios.post(this.$baseUrl+'/api/master/airtimeprice',{
                    'name_airtime_price':this.newPurchaseOrder.name_airtime_price,
                    'price':this.newPurchaseOrder.price,
                },
                {
                    'headers':
                        {'Authorization':'Bearer '+localStorage.getItem('accessToken')}
                }).then((result)=>{
                    console.log(result)
                    this.savingNewStock=false
                    this.newStockSaved=true
                    this.getAirtimePrices()
                    setTimeout(() => {
                        this.formStockActive=false
                        this.newStockSaved=false
                    }, 1500);
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                        localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err.response)
                    this.savingNewStock=false
                    this.errorNewStock=true
                })
            },
            deleteModalClose(){
                console.log('test')
            },
            deleteData(){
                this.deleteState=true
                axios.delete(this.$baseUrl+'/api/master/airtimeprice/'+this.stocks[this.selectedToDelete].id,{
                    headers:{'Authorization':'Bearer '+ localStorage.getItem('accessToken')}
                })
                .then((result)=>{
                    if(result.status==200){
                        this.stocks.splice(this.selectedToDelete,1);
                        this.deleted=true;
                        setTimeout(() => {
                            this.deleted=false;
                        }, 1500);
                        
                    }else{
                        this.deleteFail=true
                    }
                    this.deleteState=false
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                        localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err.response)
                    this.deleteState=false
                    this.deleteFail=true
                })
            },
            deleteModalClose(mdl){
              if(this.deleteState){
                console.log('deleting')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-delete-po');
              }
            }
            
        },
    }
</script>
<style>
.dropdown-menu{
    display:none;
}
</style>
